export default __webpack_public_path__ + "static/media/sayas-logo.89ae4e06.png";